import dayjs from "dayjs";
import { ChannelEnum, EndScheduleEnum, TypeEnum } from "../constants/enums";

export const calculateDeliverySeconds = (
  memberCount: number,
  channel: ChannelEnum | null,
): number => {
  switch (channel) {
    case ChannelEnum.Sms:
      return Math.max(memberCount, 60);
    case ChannelEnum.WhatsAppStandard: {
      const daysNeeded = Math.max(1, Math.ceil(memberCount / 30));
      return daysNeeded * 24 * 60 * 60;
    }
    case ChannelEnum.WhatsAppPremium: {
      const daysNeeded = Math.max(1, Math.ceil(memberCount / 250));
      return daysNeeded * 24 * 60 * 60;
    }
    default:
      return 12 * 24 * 60 * 60;
  }
};

export type RecurringEndOptions = {
  scheduleEndType?: number;
  endDate?: dayjs.Dayjs;
  maxOccurrences?: number;
  repeatDays?: number[];
  repeatMonth?: number;
  frequency?: number;
};

export const calculateCampaignEndDate = (
  startDate: string | dayjs.Dayjs,
  memberCount: number,
  channel: ChannelEnum | null,
  recurring?: RecurringEndOptions,
): string => {
  const start = dayjs(startDate);

  const deliveryMs = calculateDeliverySeconds(memberCount, channel) * 1000;
  const deliveryEnd = start.add(deliveryMs, "millisecond");

  if (recurring) {
    const {
      scheduleEndType,
      endDate,
      maxOccurrences,
      repeatDays,
      repeatMonth,
      frequency,
    } = recurring;

    if (scheduleEndType === EndScheduleEnum.OnSpecificDate && endDate) {
      return dayjs(endDate)
        .add(deliveryMs, "millisecond")
        .format("YYYY-MM-DD HH:mm");
    }

    if (
      scheduleEndType === EndScheduleEnum.AfterOccurrences &&
      maxOccurrences
    ) {
      if (frequency === TypeEnum.Recurring_Monthly) {
        const lastRunStart = start.add(
          (maxOccurrences - 1) * (repeatMonth ?? 1),
          "month",
        );
        return lastRunStart
          .add(deliveryMs, "millisecond")
          .format("YYYY-MM-DD HH:mm");
      }
      if (frequency === TypeEnum.Recurring_Weekly) {
        const daysPerWeek = repeatDays?.length || 1;
        const lastRunWeek = Math.floor((maxOccurrences - 1) / daysPerWeek);
        const lastRunStart = start.add(lastRunWeek, "week");
        return lastRunStart
          .add(deliveryMs, "millisecond")
          .format("YYYY-MM-DD HH:mm");
      }
    }

    return start.add(1, "year").format("YYYY-MM-DD HH:mm");
  }

  return deliveryEnd.format("YYYY-MM-DD HH:mm");
};
